import { DonationType } from "@/constants";
import { DonorListComponent } from "./DonorListComponent";

export function FoundingDonors() {

    return (
        <DonorListComponent
            type={DonationType.DISCRETIONARY_MONEY}
        />
    )
}